<div class="container-fluid mt-5">
  <div class="powered-by">
    Powered by
  </div>
  <div class="text-center your-places-logo-wrapper">
    <a target="_blank" href="https://www.micromerchantsystems.com/">
      <img class="your-places-logo" src="./assets/micromerchant.png" />
    </a>
  </div>

  <div class="row mb-2">
    <div class="col-md-12 text-center">
      <a href="#" class="mute-link">Privacy policy</a>
      <a href="#" class="mute-link">Terms & Conditions</a>
      <a href="#" class="mute-link">Cookies</a>
    </div>
  </div>
</div>
